import { z } from 'zod'

/** Payload to check if a reset password token is valid. */
export const CheckResetTokenPayload = z.object({
    token: z.string().min(1),
})

/** Response to check if a reset password token is valid. */
export const CheckResetToken = z.object({
    is_valid: z.boolean(),
})

export type CheckResetToken = z.infer<typeof CheckResetToken>

/** Payload to reset the password in the frontend. */
export const ResetPasswordPayloadFrontend = z.object({
    password: z
        .string()
        .min(12)
        .regex(/^(?=(?:.*[a-z]){2,})/u) // At least 2 lowercase
        .regex(/^(?=(?:.*[A-Z]){2,})/u) // At least 2 uppercase
        .regex(/^(?=(?:.*\d){2,})/u) // At least 2 digits
        .regex(/^(?=(?:.*[^A-Za-z\d]){2,})/u) // At least 2 special chars
        .min(12),
    passwordConfirmation: z.string().min(12),
})

export type ResetPasswordPayloadFrontend = z.infer<
    typeof ResetPasswordPayloadFrontend
>

/** Payload to reset the password. */
export const ResetPasswordPayload = z.object({
    token: z.string().min(1),
    password: z
        .string()
        .min(12)
        .regex(/^(?=(?:.*[a-z]){2,})/u) // At least 2 lowercase
        .regex(/^(?=(?:.*[A-Z]){2,})/u) // At least 2 uppercase
        .regex(/^(?=(?:.*\d){2,})/u) // At least 2 digits
        .regex(/^(?=(?:.*[^A-Za-z\d]){2,})/u) // At least 2 special chars
        .min(12),
})

export type ResetPasswordPayload = z.infer<typeof ResetPasswordPayload>
